import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, ClearIcon, Flex, Input, Text } from '@modusign/design-system';
import { useCallback } from 'react';

import useSearchFilterContext from '@app/features/addressBook/hooks/useSearchFilterContext';

interface SearchBarProps {
  resultCount: number;
  title: string;
  onReload: () => void;
}

export default function SearchBar({ resultCount, title, onReload }: SearchBarProps) {
  const { displayKeyword, searchKeyword, setDisplayKeyword, setPage } = useSearchFilterContext();

  const handleReset = useCallback(() => {
    setDisplayKeyword('');
    setPage(1);
  }, [setDisplayKeyword, setPage]);

  return (
    <Flex
      alignItems={['flex-start', 'center']}
      flexDirection={['column', 'row']}
      height={['unset', null, '56px']}
      justifyContent="space-between"
      mb={[6, 7]}
      px={['unset', null, 4]}
    >
      <Box data-testid="contacts-count" mb={[4, null, 'unset']} width={['100%', null, '50%']}>
        {searchKeyword ? (
          <Flex alignItems="center">
            {title} 검색 결과 :
            <Text color="textEmphasisBase" fontWeight="medium" ml="2px">
              {resultCount.toLocaleString()}
            </Text>
          </Flex>
        ) : (
          <Text>
            {title} : <Text fontWeight="medium">{resultCount.toLocaleString()}</Text>
          </Text>
        )}
      </Box>
      <Box sx={{ position: 'relative' }} width={['100%', null, '278px']}>
        <Box
          as="button"
          color="textNeutralLight"
          lineHeight="1.3em"
          sx={{ position: 'absolute', top: 3, left: 4 }}
          type="button"
          onClick={onReload}
        >
          <FontAwesomeIcon icon={faSearch} />
        </Box>
        <Input
          placeholder="이름 또는 회사명으로 검색"
          sx={{ paddingLeft: 8 }}
          value={displayKeyword}
          onChange={(event) => setDisplayKeyword(event.target.value)}
        />
        {displayKeyword && (
          <Box
            as="button"
            sx={{
              position: 'absolute',
              right: 3,
              top: 2,
            }}
            onClick={handleReset}
          >
            <ClearIcon />
          </Box>
        )}
      </Box>
    </Flex>
  );
}
